export const validateAgentRole = (groups) => {
  const agentModeRole = ['internal-agents', 'external-agents', 'tso-supervisor'];
  return (groups && groups.length) ? groups.some(group => agentModeRole.includes(group)) : false;
};
